import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class Form extends Vue {
	@Prop()
	private dataForm!: any;

	@Prop({ default: false })
	public readonly;

	public trigger(): void {
		// TRIGGER ERROR
		for (const data in this.dataForm) {
			if (!this.dataForm[data].disabled || this.dataForm[data].checkEvenIfDisabled) {
				this.dataForm[data].trigger = !this.dataForm[data].trigger;
			}
		}
	}

	public checkSuccess(): boolean {
		for (const data in this.dataForm) {
			if (this.dataForm[data].error && (!this.dataForm[data].disabled || this.dataForm[data].checkEvenIfDisabled)) {
				return false;
			}
		}

		return true;
	}

	public clear(): void {
		// CLEAR
		for (const data in this.dataForm) {
			this.dataForm[data].clear = !this.dataForm[data].clear;
		}
	}

	public resetState(): void {
		// CLEAR
		for (const data in this.dataForm) {
			this.dataForm[data].reset = !this.dataForm[data].reset;
		}
	}

	@Watch("readonly")
	public readtOnly(): void {
		if (this.readonly) {
			for (const data in this.dataForm) {
				this.dataForm[data].disabled = true;
			}

			this.$forceUpdate();
		}
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/Form.ts